/**
 * Calculate the delay for an exponential backoff strategy.
 *
 * @param attempts The number of attempts that have been made.
 * @param baseDelay The base delay in milliseconds.
 * @param maxDelay The maximum delay in milliseconds.
 * @param factor The factor by which the delay increases.
 *
 * @returns The delay in milliseconds.
 */
export function exponentialBackoff(attempts, baseDelay = 1000, maxDelay = Number.POSITIVE_INFINITY, factor = 2) {
    return Math.min(baseDelay * Math.pow(factor, attempts), maxDelay);
}
